import {
  Building,
  ComponentDesignLayoutModel,
  Insertion,
  Level,
  ModelCategory,
  ProjectLayoutModel,
} from '@paragon/contract-library';
import { assertExhaustiveSwitch } from '@paragon/utilities';

export function isComponentDesignInsertion(insertion: Insertion) {
  switch (insertion.type) {
    case 'NormalComponent':
    case 'LayoutComponent':
      return true;

    case 'HierarchyModel':
      return false;

    default:
      assertExhaustiveSwitch(insertion.type);
  }
}

/** translates from the server side `modelType` to a `ModelCategory` used client side */
export function getCategoryForLayoutModel(
  model: ProjectLayoutModel | Building | Level | ComponentDesignLayoutModel,
): ModelCategory {
  switch (model.modelType) {
    case 'Project':
      return ModelCategory.Project;

    case 'Building':
    case 'Level':
      return ModelCategory.IntermediateModel;

    case 'ComponentDesign':
      return ModelCategory.ComponentDesign;

    default:
      assertExhaustiveSwitch(model);
  }
}
